import { features } from '@/mocks/data';

export default function Features() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            核心功能
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            六大核心功能，全面赋能
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            91牛平台为您提供一站式解决方案，从智能匹配到数据分析，助您高效完成每一项工作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`} />
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}